type Context = 'filter';

type Key = 'options' | 'groups' | 'applied';

type Value = `${Context}-${Key}`;

export type OptionItem = {
  name: string;
  id: string;
};

export const Keys: Record<Key, Value> = {
  options: 'filter-options',
  groups: 'filter-groups',
  applied: 'filter-applied',
};
